import { render, staticRenderFns } from "./quota.vue?vue&type=template&id=e3b6e1ee&"
import script from "./quota.vue?vue&type=script&lang=js&"
export * from "./quota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports